var render = function render(_c,_vm){return _c('a',{class:[_vm.data.class, _vm.data.staticClass],attrs:{"href":_vm.props.href,"target":"_blank","rel":"noopener noreferrer"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }